import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetPatientItemDocument,
  PatientItemDataFragment,
} from '../../types/api/graphql';

export function usePatientItem(id: string | null | undefined) {
  const { data: patientItemData, loading: patientItemLoading } = useCacheQuery(
    GetPatientItemDocument,
    {
      variables: {
        id: id ?? '',
      },
      skip: !id,
    }
  );

  const data: PatientItemDataFragment | undefined = useMemo(
    () => (patientItemData?.patient as PatientItemDataFragment) ?? undefined,
    [patientItemData?.patient]
  );

  return {
    data,
    loading: patientItemLoading,
  };
}
